import React from 'react';
import { Box, Paper, Typography, CircularProgress, Skeleton, Stack } from '@mui/material';

const LoadingState = ({
  title = 'Loading...',
  subtitle,
  showSkeleton = false,
  skeletonRows = 6,
  height,
}) => {
  if (showSkeleton) {
    return (
      <Paper sx={{ borderRadius: 2, p: 2 }}>
        <Stack spacing={2}>
          <Skeleton variant="text" width="30%" height={28} />
          {Array.from({ length: skeletonRows }).map((_, i) => (
            <Stack key={i} direction="row" spacing={2} alignItems="center">
              <Skeleton variant="circular" width={32} height={32} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton variant="text" width="40%" height={16} />
              </Box>
              <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 1 }} />
            </Stack>
          ))}
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 2, height }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: height || 200, textAlign: 'center' }}>
        <CircularProgress size={36} />
        <Typography variant="subtitle1" sx={{ mt: 2 }}>{title}</Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        )}
      </Box>
    </Paper>
  );
};

export default LoadingState;


